// Der Store wird ueber den Standard-Import geladen; da der Router selbst per
// require() eingebunden wird (siehe index.js), nutzen wir hier auch require.
const storeModule = require("../store");
const store = storeModule.default || storeModule;

function requireSuperAdmin(to, from, next) {
    const user = store && store.state && store.state.user;
    if(user && user.role === 'super_admin') {
        return next();
    }
    // Kein Super-Admin: zurueck zur Library (oder Login wenn gar nicht eingeloggt)
    next('/library');
}

const route = {
    path: '/settings',
    children: [
        {
            path: '',
            components: {
                default:
                    () => import(/* webpackChunkName: "settings" */ '../../components/views/settings/settings.vue'),
                tabBar:
                    () => import(/* webpackChunkName: "settings" */ '../../components/views/settings/tabBar.vue'),
            },
            beforeEnter: requireSuperAdmin,
        },
    ],
}

module.exports = route;